/** Só antecipa desconto quando a consulta do servidor confirmou o direito ao benefício. */
export function eligiblePlanProduct(subscription, productId) {
    if (subscription?.planBenefitEligible !== true) return null;
    // Os IDs podem vir como texto no seletor e como número na resposta do plano.
    return subscription.plan?.planProducts?.find(product => String(product.productId) === String(productId)) || null;
}
